export default {
  email: null,
  full_name: null,
  beds24ApiKey: null,
  role: null,
  lang: null,
  plan_id: null,
  first_name: null,
  last_name: null,
  isSyncInProgress: null,
  onBoarding: null,
  onboarding_step: null,
  confirmed: 1,
  username: null,
  is_team_member: null,
  parent_id: null,
  parent: null,
  right: null,
  setting: {},
  stripe_id: null,
  card_brand: null,
  card_last_four: null,
  stripe_token: null,
  is_subscription_active: null,
  prelaunched_at: null,
  prelaunched_onboarding_at: null,
  currency: {},
  trial_period: null,
  last_sync_time: null,
  api_key: null,
  web_key: null,
  affiliate_id: null,
  airbnb_should_sync: 0,
  airbnbapi_enabled: null,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/account/state.js